<template>
    <div class="information">
        <div class="product_details_title">
            <el-breadcrumb separator-class="el-icon-arrow-right" class="more">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/newsInformation' }">新闻资讯</el-breadcrumb-item>
                <el-breadcrumb-item>{{ tagName }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="widthrules">
            <div class="news_b_b">
                <div class="rights">
                    <div class="left_boxs" v-for="item in classNewsList" :key="item.id" @click="article(item.id)">
                        <div class="leftInfo">
                            <img :src="item.pic" alt="">
                        </div>
                        <div class="rightInfo">
                            <div class="tuwen">{{ item.title }}</div>
                            <div class="jianjie">{{ item.brief }}</div>
                            <!-- <div class="date">{{item.date}}</div> -->
                        </div>
                    </div>
                    <el-pagination background layout="prev, pager, next" :page-size="pageSize"
                        :current-page="currentPage" :total="pageTotal" @size-change="handleSizeChange"
                        @current-change="handleCurrentChange">
                    </el-pagination>
                </div>
            </div>
        </div>
        <v-footer></v-footer>
    </div>
</template>

<script>
// import axios from 'axios'
import vFooter from '../../common/footer.vue';
import { getGWClassNewsList } from '@/api/index';
export default {
    name: 'information',
    components: {
        vFooter
    },
    data() {
        return {
            classNewsList: [],
            pageSize: 5,
            currentPage: 1,
            pageTotal: 0,
            languageType: '1',
            tagName: '',
            params: {}
        };
    },
    created() {
        this.showParams();
        // if(sessionStorage.getItem('currentPage')){
        //     this.currentPage =  Number(sessionStorage.getItem('currentPage'));
        // }
        // if (sessionStorage.getItem('languageType')) {
        //     this.languageType = sessionStorage.getItem('languageType');
        // }
        this.getGWClassNewsList();
        // window.addEventListener('setItem', () => {
        //     this.languageType = sessionStorage.getItem('languageType');
        //     this.getGWClassNewsList();
        // });
    },
    mounted() {
        window.addEventListener("beforeunload", () => {
            sessionStorage.removeItem('currentPage');
        });
        this.$nextTick(function () {
            this.scrollTos();
        }, 2000);
    },
    methods: {
        showParams() {
            this.params = JSON.parse(this.$route.query.params);
            this.tagName = this.$route.query.name;
        },
        handleSizeChange(val) {
            this.pageSize = val;
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getGWClassNewsList();
        },
        getGWClassNewsList() {
            // axios.get('/getNews').then((res) => {
            //     this.pageTotal = res.data.data.news.length;
            //     if(this.currentPage == 1){
            //         this.newsLists = res.data.data.news.slice(0,5);
            //     }else if(this.currentPage == 2){
            //         this.newsLists = res.data.data.news.slice(5,10);
            //     }
            // })
            let params = {
                pageSize: this.pageSize,
                pageNum: this.currentPage,
                classId: this.params,
                language: this.languageType
            };
            getGWClassNewsList(params).then(res => {
                // console.log('分类新闻列表查询', res.rows);
                this.pageTotal = res.total;
                this.classNewsList = res.rows;
            });
        },
        scrollTos() {
            window.scrollTo({
                //滚动到元素位置
                top: sessionStorage.getItem('position_company'),//推荐使用，getBoundingClientRect 相对于当前视口的位置
                behavior: "smooth" // 平滑滚动
            });
        },
        article(e) {
            sessionStorage.setItem('currentPage', this.currentPage)
            this.$router.push({
                path: '/articleInfo',
                query: { params: JSON.stringify({ id: e }) }
            });
        }
    }
};
</script>

<style scoped lang="less">
@deep: ~'>>>';

.widthrules {
    max-width: 17.075rem;
}

.product_details_title {
    background: #fff;
    padding: .375rem 3.25rem;

    // border-bottom: 1px solid #eee;
    .more {
        // float: right;
        font-size: .175rem;
    }
}

.information {
    // height:100vh;
    // background-color: #e1e1e1;
    -webkit-user-select: none;
    /* Safari */
    -moz-user-select: none;
    /* Firefox */
    -ms-user-select: none;
    /* IE10+/Edge */
    user-select: none;
    /* Standard syntax */
}

.news_b_b {
    // width:80%;
    margin: auto;
    padding: .625rem 0;
    background-size: 100% 100%;

    // background-image: url(../../../assets/img/images/newsInfoBg.png);
    .rights {
        display: flex;
        flex-direction: column;
        gap: .25rem;
        width: 100%;
    }
}

.left_boxs {
    display: flex;
    padding: .25rem;
    background: #f7f7f7;
    // border-bottom: 1px solid rgb(149, 149, 149);
    margin-bottom: .125rem;

    .leftInfo {
        width: 15%;
        // margin-right:50px;
        margin: auto;
        height: 1.5625rem;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: .125rem;
        }
    }

    .rightInfo {
        width: 80%;
        margin: auto;

        .tuwen {
            font-size: .25rem;
            // padding-top:20px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            -o-text-overflow: ellipsis;

            img {
                width: .3125rem;
                vertical-align: middle;
                margin-right: 2%;
            }
        }

        // .tuwen:hover{color: #409EFF;cursor: pointer;}
        .jianjie {
            padding: .25rem 0;
        }

        .date {
            font-size: .1875rem;
            margin-top: .125rem;
            margin-left: .4625rem;
        }
    }
}

.left_boxs:hover {
    cursor: pointer;
    color: #2f5597;
}

.oneBoxs {
    .title {
        width: 2.5rem;
        margin: .625rem;

        .bigTitle {
            text-align: center;
            font-size: .5rem;
            font-weight: bold;
        }

        .smallTitle {
            font-size: .2rem;
            color: #2f2e2e;
            text-align: center;
        }
    }
}

// .footer{background-image: url(../../assets/img/images/footerBg3.png);}
.moreInfo_icon {
    text-align: center;
    margin-top: 80%;
}

.moreInfo_icon img:hover {
    cursor: pointer;
    width: 1.4375rem !important;
}

.el-pagination {
    text-align: center;
    margin-top: .25rem;
}
</style>
